import { Card, Input } from "reactstrap";
import { DropdownLabel } from "../dropdown/DropdownLabel";
import { orderTerms, purchaseCompanies, purchaseShippings } from "../../data";

const PurchaseOrderInformations = ({
  terms,
  setTerms,
  company,
  setCompany,
  shipping,
  setShipping,
  freightBillingAcc,
  setFreightBillingAcc,
}) => {
  return (
    <Card className="border-1 h-100 rounded-0  bg-secondary-color p-2 p-lg-2 my-2 my-lg-0 billingShippingCard">
      <div className="d-flex justify-content-between align-items-center">
        <h5 className="primary-color ">PO Details</h5>
      </div>
      <DropdownLabel
        placeholder={" Terms"}
        label={"Terms"}
        options={orderTerms?.map((i) => i.value)}
        className={" w-100 mb-2"}
        value={terms}
        width="100%"
        onSelect={(e, value) => {
          setTerms(value.children);
        }}
      />
      <DropdownLabel
        placeholder={" Shipping"}
        label={"Shipping"}
        options={purchaseShippings?.map((i) => i.value)}
        className={" w-100 mb-2"}
        value={shipping}
        width="100%"
        onSelect={(e, value) => {
          setShipping(value.children);
        }}
      />
      <DropdownLabel
        placeholder={" Carrier"}
        label={"Carrier"}
        options={["Cheapest Option", ...(purchaseCompanies?.map((i) => i.label) || [])]}
        className={" w-100 mb-2"}
        value={company || "Cheapest Option"}
        width="100%"
        onSelect={(e, value) => {
          setCompany(value.children);
        }}
      />
      <div className="d-flex align-items-center justify-content-between mb-2">
        <p className="mb-0 fw-bold">Freight Account </p>
        <Input
          style={{ width: "50%", height: "30px" }}
          value={freightBillingAcc}
          type={"text"}
          placeholder="Enter Freight  Account"
          onChange={(e) => setFreightBillingAcc(e.target.value)}
        />
      </div>
    </Card>
  );
};

export default PurchaseOrderInformations;
